const { createMachine } = require("xstate");
const actions = require("./actions");
const guards = require("./guards");
const services = require("./services");

const ReviewFiveWhysMachine = createMachine(
  {
    /** @xstate-layout N4IgpgJg5mDOIC5SQJYBcC0AzFA3MGA7gBYCesAdChADZgDEAygCoCCASswNoAMAuolAAHAPax0KEQDtBIAB6IATAGYKATgBsPRQEZlAdh4BWHgA5TRtQBoQpRBlOKeFHtoAsy5Tp36NG-W4AvoE2qJg4+ERklACGAMZoeGAUEGA4UmAABEIATiIARnQAtvQAcgCiABrc-LKi4onSsgoIOooUGmpuejpqXRaeGkY2dggYymrtioZuPPpqxlrKc8GhEOjYSVHkFPGJ+ClpKBnZeYVgJQAK7ADyAEIAMuUAsgD6AMIAEqylAOLlABFeAIkCB6hImqCWhgVKYKKYNB4DN4jIZFGp9CN7G4TOoeG5Zm0dP43Fp9KtwOtwlsSDs9klDuksrkCsV6Kw7j8ATdSq92OUAIoAVXKLEBwLqYghMihiB0ZiM6iMqJ4vV8iKxYyMBIouj0GNM+kc+nJIUpGwiBFpsQSDNpmR09Gu5QAagBJG5CxgS0Hgxoy0AtRSmNwUNzTRx+HRGLx6Ya2ezKTq6tTKUzKIxEzNzU1rC006K7W0He06ChSERoTLpGI0dmlRgAdXK7A+3z+4tqvql-ua9l6Gl1ihMPA0BlMamVc01oeUigJE1mAWDC4pYU2kWtRf2yVL5cr1eOtbKVRqIOEPckAfkiG66jU8tV5gnKlTmsUH91nW0akcE9mihrlSG5WoW9IlmQmSKE6-Lup63pdheDRXn2YzKHeGhODw6FJtq0ZGBo76ZverjKsSXQmgSQH5puYHFrukHtBWVY1nWzwcAA0q8rCMK8ABibqlKwDw+kh0qoT0HQ8AaRhOEYCJdJqJiDhYxLYX0igaNGpjUdStF0vRFD2kxB6sfWTYtm2Pz-ECiFgpekKBv2-guOGTgWI4OHWAmCBafoYYGA+iLTJ0bi5uaemgQZO5GYx+4sUedYVNUon2chjk3ggEzwvoXhuCGUb6DoIaaqpYapgsuieToQRmuulrbDaMXGRQZlCqU7HsFxPH8YJwmpX6KGyq0wYuLCXghW0FiET5WnOPMywBOG6YLDpdXAQ1W7gQxpBQa1iX0O8PICewzwDQ514tEMoYERY8zTYavSlaSFBJpMRpuA+MbTLpIGNdudpxWZNzMJ8lmXDcjCMG6jzlB8rBeqKVkdrZ55peJw0EvNZiuAp+rFUpkyvcGxXypOiLmL9m10c1cVxMQYBxAA1vQ53pZdiBpnCBKvt40wYioM5zhQPiThm86qjiKzrTRUVNYDu3tPTjMs1wOho4NGXQsSFCWBmpjynOWHpjOslhphyoLIs0w6FTBbRQrmTKDBroel6bMY05aEYVhWikv05ildlBsmN00lhWYgEy5F-3bbFu2qMxh5SMenXdbxAlCSJdmaxzrQeCLFWpjVKgaAb3mjG0Zi6thRpqsG+jBnb+nyxBCfxcnx4-BZrZfNZnYaxdqEYPhupGuhmbzJOfQzZXwbODzI7Bpp7jN3LANt07HdmclZ6SuzqHTC4uHFYay25f4mrRjrvjGNMZjzKqUd5jHW2GfaqhtR1nHcRnfXZ4PA+w19QUCNCadET8Jj6yvkbdQThNKmG0GObQa9Y7v0gp-A6R1SgnTOjnIew1rq6zLqiX8t0ioVzlJmQct9SFdGWBGVBb9abt2BqDcGkNoaw3hojXifcUYe17JjM2YViqfX1o3E0V954iy0ppX8Ph5hGiYTTR2qhlbM1ZvgoBXtZgL38KmEOZJvCYh8t4fKIsTRaBqnoec6IVEO03uohmmi1aAM9plUM8wy74hUKqaSIZFBXxqnCRR1juhznDGoBxrcdqZDcC7OC7ttEeOhOhMsmFXCfQJI3LQ0wr7UNAVoVEiIAgLDaDEjecTQxJzMmnX+vUs6CKGl7Gx8InCpnyvoEpGJ4yV0fmGbUARlQhU6ZUuO9oammQOt3Zsvd2w2WaVrfsBFiHakRNoTw19TGV3MM4JwxITCi0QamcZ6DdpTISinJKp4ll5x1OGXwqIbZjk0O+HM8IcQGxxAc0kZyWHxP2tc+g7V6k9Uzv1FJQjWlpl1q4LQkxpI+BxFfK2HQ9ltCTMtMu-zHahjMtg3BdzUJDDLOY4Mq0aqWEoa0A2qgPD6lJE+fwGhcWb3xQdEGYNWwQyhjDJ4PDGBI34YsqFLTMroWcK4bwJzJh+NMO8k0nzUS5QRCy3wbLqkUA0arMVyysp9BcF0VaJppJFSCWY7poYarYVJd0yc2pNXx0BTq1m6t96pPsIObwZdiofnHB+UkV8rUi1mN0Pwc5ZLzidfaIwJ4Up6rztlfKy0uivP8Dod8Bh2iIMfvJf86YY2QTjbMyyIqB4euhZlEeqyCLrIAlsye75pjtD8KXE0BsFLKCLbtONzokkIXcVWtJPtXBc2zZMPpSgPkhksPOEMqZ-A9syHGrlHC+XcPeAjIVfCFkVu7DoiVswXCqhCY8zMyLm2N11OGaM+VsLLFttHP6zCGQAFchAQBiIkKQUB6AQGkMkY4uARBM2SB+r9aACDU3IMSzGZZDQxmUuiaYGY3DvjIUqSYHhwwxipU6iD37jh-rADkPIOQKBCBoN+rAIgchFAoIRqDL7ohwd0Y4eEvQn7EgjIg2eShymgK6CoJwXg-BrRfixxxyRYBvriHEOAsBDoPEhuUNj1ayQpiQ25CcrgLWjGWFoE92k2izHknoJ1pHyP0H5MwdgABNdTQYMQi0jZMI24ifCakM1K1U-gz7SUnE62TRQigxByKQGzrtyiNic4mUdxgjRBQIjspQExnATHcssfE8on2SZg7EigIWwsRZBZcAErBmBqcTahcwYZirfU0j4CcZd3yIMVL4ci4t8oU0qXEaQOB6OZBiPkGIUgANSHZJyUo3JShxdaCYgKWk5HaEWPxsY6YyweAUvIpMXgjB9YGygIbI2xsTcOj8d45QHjcWm7N+bIYyzaAXeqfEYV0M+QwH4Zws6irFX1qSPLEUpOxLKxVqrrw7jlA4JZZgNwOLlDmzV4a177VphxL0EM-5vPzjULrDEhhqqBO7RSCsqR4CgnqvbCnYlh1euVFptDH5dPaE1CPbCZZ0eeA8IFpwrLn0FaoLQMAlbxUtDJrrOdKg5xzkXR90YGAuihlHCXXoNVcoxk1aL-V4wJwdF9viUKz42eWEHIZiYpMPyTCdakJkpxWQXG13nZMBEvBjsMBiB8Jvq6-nQvMboRVRwaoF9TqpzqdBO+HvOUMH4RxjiS1OVLYxT6ucnNoKxgeJPA8FxMyCZZamJUj8NDAs4HwBFyuHbLrPPuPk40MBYaZozDksMuxQRevYwmjK5D8CpPIeBpcsUMf5UzLBMHORurft6F4PZ6hAioLCu6TKFfKJgFU+Vknjv8xJ-PdGHJP1i7fPGrLMJ0bfD45hDCTxv9pBs-AfTaAdkPLcw8tR1Yflov4hwhNDp0X3a+DNEzXyzoEhkTRpP7ry54Jzv72CiZjzpgY5TzUrra5Z449a5JVRL6P75ah6QFbwF7XLQGtD+RaRiw2qohxjEjSI+AdByLKjIYXzLqYIEEz504ICkj+QWBzAKR5JJj-5yi6DEG0FTiYSqqMHaouJMyEEIiWIW5+CzATCZjBKjjwjSRjgIhxiTzLpuCEEwj4hrKkgNr7ZeZmKWBba6B+6KIV5YHZ44HnKAr4G1iEE6yeASy+CGhyqBxmJ0oBSMrWIIjzBaFAqOEsFi63gPhhg8yeAfQqhTq0p6A+GLh+EGKBFv4hH6q5TqDFS+AZhlKyRJ7EhGigKLyTiNxfRZ5U7P64FGCEGaDqARIfhGjfJe4+Q96b59BhzdLBiZjWEVEQGGRMbEY6FeARHvbog1QUwlQtGGjtBzAERmD94WBBbgFoIxSybyaKZSF45oZFTmAeAqB-bebSSKiIivJYorTlEbS2ExRWZ0aEHajtD6wX5KJHFJ4+bGZaT3EY4WbLGvoHDFbhajC06hEIAWDlQxjhgZiy5N7vilFjyIoTQmieCHZSCDZFDDajbjYZS5wSTeCqBpiphmpoY4jKBs7fbKqdBKJUr2LBCBBAA */
    predictableActionArguments: true,

    id: "edit-five-whys",

    context: {
      qmsToolApiUrl: undefined,
      authentication: {
        token: undefined,
      },
    },

    states: {
      idle: {
        on: {
          START: {
            target: "active",
            cond: "validCreateRequest",
            actions: [
              "saveReportId",
              "saveAuthentication",
              "saveInitialChangeSet",
            ],
          },
        },
      },

      active: {
        states: {
          "define problem": {
            on: {
              NEXT: {
                target: "why 1.not final",
                cond: "validProblemStatement",
              },

              PROBLEM_CHANGED: {
                target: "define problem",
                internal: true,
                actions: "saveProblemStatement",
              },

              ABANDON_REQUESTED: "#edit-five-whys.confirm abandon",
            },
          },

          "why 1": {
            on: {
              PREVIOUS: "define problem",
            },

            states: {
              "not final": {
                on: {
                  ANSWER_CHANGED: {
                    target: "not final",
                    actions: "saveAnswer1",
                    internal: true,
                  },

                  NEXT: {
                    target: "#edit-five-whys.active.why 2.check",
                    cond: "validAnswer1",
                  },
                },
              },
            },

            initial: "not final",
          },

          "why 2": {
            on: {
              PREVIOUS: "why 1.not final",
            },

            states: {
              "not final": {
                on: {
                  MARK_AS_FINAL: {
                    target: "final",
                    cond: "validAnswer2",
                    actions: "saveAnswer2AsFinal",
                  },

                  ANSWER_CHANGED: {
                    target: "not final",
                    internal: true,
                    actions: "saveAnswer2",
                  },

                  NEXT: {
                    target: "#edit-five-whys.active.why 3.check",
                    cond: "validAnswer2",
                  },
                },
              },

              final: {
                on: {
                  UNMARK_AS_FINAL: {
                    target: "not final",
                    actions: "resetFinalAnswer",
                  },

                  CONFIRM: "#edit-five-whys.active.summary",

                  OTHER_POSSIBLE_CAUSES_CHANGED: {
                    target: "final",
                    internal: true,
                    actions: "saveOtherPossibleCauses",
                  },
                },
              },

              check: {
                always: [
                  {
                    target: "final",
                    cond: "answer2MarkedFinal",
                  },
                  "not final",
                ],
              },
            },

            initial: "check",
          },

          "why 3": {
            on: {
              PREVIOUS: "why 2.check",
            },

            states: {
              "not final": {
                on: {
                  MARK_AS_FINAL: {
                    target: "final",
                    cond: "validAnswer3",
                    actions: "saveAnswer3AsFinal",
                  },

                  ANSWER_CHANGED: {
                    target: "not final",
                    internal: true,
                    actions: "saveAnswer3",
                  },

                  NEXT: {
                    target: "#edit-five-whys.active.why 4.check",
                    cond: "validAnswer3",
                  },
                },
              },

              final: {
                on: {
                  UNMARK_AS_FINAL: {
                    target: "not final",
                    actions: "resetFinalAnswer",
                  },

                  CONFIRM: "#edit-five-whys.active.summary",

                  OTHER_POSSIBLE_CAUSES_CHANGED: {
                    target: "final",
                    internal: true,
                    actions: "saveOtherPossibleCauses",
                  },
                },
              },

              check: {
                always: [
                  {
                    target: "final",
                    cond: "answer3MarkedFinal",
                  },
                  "not final",
                ],
              },
            },

            initial: "check",
          },

          "why 4": {
            on: {
              PREVIOUS: "why 3.check",
            },

            states: {
              "not final": {
                on: {
                  MARK_AS_FINAL: {
                    target: "final",
                    cond: "validAnswer4",
                    actions: "saveAnswer4AsFinal",
                  },

                  ANSWER_CHANGED: {
                    target: "not final",
                    internal: true,
                    actions: "saveAnswer4",
                  },

                  NEXT: {
                    target: "#edit-five-whys.active.why 5",
                    cond: "validAnswer4",
                  },
                },
              },

              final: {
                on: {
                  UNMARK_AS_FINAL: {
                    target: "not final",
                    actions: "resetFinalAnswer",
                  },

                  CONFIRM: "#edit-five-whys.active.summary",

                  OTHER_POSSIBLE_CAUSES_CHANGED: {
                    target: "final",
                    internal: true,
                    actions: "saveOtherPossibleCauses",
                  },
                },
              },

              check: {
                always: [
                  {
                    target: "final",
                    cond: "answer4MarkedFinal",
                  },
                  "not final",
                ],
              },
            },

            initial: "check",
          },

          "why 5": {
            on: {
              NEXT: {
                target: "summary",
                cond: "validAnswer5",
                actions: "saveAnswer5AsFinal",
              },

              ANSWER_CHANGED: {
                target: "why 5",
                actions: "saveAnswer5",
                internal: true,
              },

              PREVIOUS: "why 4.check",

              OTHER_POSSIBLE_CAUSES_CHANGED: {
                target: "why 5",
                internal: true,
                actions: "saveOtherPossibleCauses",
              },
            },
          },

          updating: {
            invoke: {
              src: "updateFiveWhys",
              id: "update-five-whys",
              onDone: {
                target: "success",
                actions: "resetChangeSet",
              },
              onError: {
                target: "error",
                actions: "saveError",
              },
            },
          },

          success: {
            on: {
              CLOSE: "#edit-five-whys.idle",
            },

            type: "final",
          },

          error: {
            on: {
              RETRY: "updating",
            },

            entry: "notifyError",
            type: "final",
          },

          summary: {
            on: {
              REVIEW: "define problem",
              UPDATE: "updating",
            },
          },
        },

        initial: "define problem",

        on: {
          UPDATE_BEARER_TOKEN: {
            target: "active",
            internal: true,
            cond: "validToken",
            actions: "saveToken",
          },
        },
      },

      "confirm abandon": {
        on: {
          ABANDON: {
            target: "idle",
            actions: "resetChangeSet",
          },

          CANCEL_ABANDON: "active.define problem",
        },
      },
    },

    initial: "idle",
  },
  {
    actions: actions,
    guards: guards,
    services: services,
  },
);

export { ReviewFiveWhysMachine };
